import { NgClass, NgFor } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { SiteSvgsComponent } from '@curbnturf/custom-svgs/src/lib/site-svgs/site-svgs.component';
import { ILandType, LandType } from '@curbnturf/entities';
import { EnumSelectorPipe } from '@curbnturf/form-helpers';
import { Subscription } from 'rxjs';

@Component({
  selector: 'curbnturf-land-types-form',
  templateUrl: './land-types-form.component.html',
  styleUrls: ['./land-types-form.component.scss'],
  standalone: true,
  imports: [NgFor, NgClass, SiteSvgsComponent],
})
export class LandTypesFormComponent implements OnChanges, OnDestroy {
  @Input() landTypes: FormArray<FormControl<ILandType['type'] | null>>;
  @Input() boondock: boolean = false;

  _landTypes: { key: string; value: string }[];

  get landTypesArray(): { key: string; value: string }[] {
    if (!this._landTypes) {
      this._landTypes = new EnumSelectorPipe()
        .transform(LandType);
    }

    return this._landTypes;
  }

  selectedHash: { [id: string]: boolean };

  private subscriptions: Subscription[] = [];

  ngOnChanges(changes?: SimpleChanges) {
    if (changes?.landTypes?.currentValue) {
      // if for some reason the form changes we should clear the subscription (which is currently they only subscription)
      this.closeSubscriptions();
      this.setSelectedHash(changes.landTypes.currentValue.controls.map((el: FormControl) => el.value));
      this.subscriptions.push(
        changes.landTypes.currentValue.valueChanges.subscribe((formChange: string[]) =>
          this.setSelectedHash(formChange),
        ),
      );
    }
  }

  ngOnDestroy() {
    this.closeSubscriptions();
  }

  closeSubscriptions() {
    this.subscriptions.forEach((sub) => {
      if (!sub.closed) {
        sub.unsubscribe();
      }
    });

    this.subscriptions.length = 0;
  }

  setSelectedHash(selectArray: string[]) {
    if (!selectArray) {
      return;
    }

    this.selectedHash = this.landTypesArray.reduce(
      (selectedHash, landType) => {
        selectedHash[landType.key] = selectArray.includes(landType.key);
        return selectedHash;
      },
      {} as { [id: string]: boolean },
    );
  }

  toggle(landType: ILandType['type']) {
    if (this.selectedHash && this.selectedHash[landType]) {
      this.landTypes.removeAt(this.landTypes.controls.findIndex(this.matchFunction(landType)));
    } else {
      this.landTypes.push(new FormControl(landType));
    }

    this.landTypes.markAsDirty();
  }

  private matchFunction(landType: string): (form: FormControl<string | null>) => boolean {
    return (landValue) => landValue.value === landType;
  }
}
